import React from 'react'

type TruckMarkerIconProps = {
  fillColor?: string
  ellipseColor?: string
  className?: string
}

export const TruckMarkerIcon: React.FC<TruckMarkerIconProps> = ({
  fillColor = '#000',
  ellipseColor = '#FFF',
  className = '',
  ...props
}) => (
  <svg
    width="30"  // 30 * 1.3
    height="40" // 40 * 1.3
    viewBox="0 0 30 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <defs>
      <filter id="dropshadow" height="130%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="2" />
        <feOffset dx="2" dy="2" result="offsetblur" />
        <feComponentTransfer>
          <feFuncA type="linear" slope="0.5" />
        </feComponentTransfer>
        <feMerge>
          <feMergeNode />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#dropshadow)">
      <path
        d="M30 15C30 21.8281 20.8594 33.9844 16.8516 39C15.8906 40.1953 14.1094 40.1953 13.1484 39C9.14063 33.9844 0 21.8281 0 15C0 6.71875 6.71875 0 15 0C23.2812 0 30 6.71875 30 15Z"
        fill={fillColor}
      />
      <ellipse
        cx="15"
        cy="14.9611"
        rx="13.125"
        ry="13.0861"
        fill={ellipseColor}
      />
    </g>
    <g transform="translate(5, 7) scale(0.033)">
      <path 
        d="M48 0C21.5 0 0 21.5 0 48L0 368c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L48 0zM416 160l50.7 0L544 237.3l0 18.7-128 0 0-96zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        fill={fillColor}
      />
    </g>
  </svg>
)